module.exports = __webpack_public_path__ + "img/icon_documents.4c1fec8c.svg";